<script>
  // Flexible logo component that accepts size and styling props
  // The logo has an aspect ratio of ~2.07:1 (width:height)
  let {size = 40, class: className = '', variant = 'default'} = $props();

  // Calculate width based on aspect ratio (937:453 ≈ 2.07:1)
  let width = $derived(Math.round((size * 937) / 453));
  let height = $derived(size);

  // Color variants for different contexts
  const variants = {
    default: '#444748', // Original dark gray
    light: '#FFFFFF', // For dark backgrounds
    gradient: 'url(#logo-gradient)' // For special occasions
  };

  let fillColor = $derived(variants[variant] || variants.default);
</script>

<svg
  class={className}
  width={width}
  height={height}
  viewBox="0 0 937 453"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-label="Selify Logo"
>
  {#if variant === 'gradient'}
    <defs>
      <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style="stop-color:#8b5cf6;" />
        <stop offset="100%" style="stop-color:#3b82f6;" />
      </linearGradient>
    </defs>
  {/if}

  <!-- "ko" path -->
  <path
    d="M228.907 51.3337L230.316 446H316.321C316.321 372.588 316.321 313.268 358.878 306.913C411.305 299.853 629.411 489.538 791.463 446C1051.1 357.308 928.491 -13.4926 687.834 55.5698C624.111 78.2609 571.765 154.652 562.351 219.5L622.978 236.444C641.307 135.108 722.009 67.2538 811.906 123.348C923.923 193.244 885.222 379.634 761.149 390.93C637.077 402.226 517.233 282.666 410.785 251.844L569.401 51.3337H464.362L321.961 223.603V51.3337H228.907Z"
    fill={fillColor}
  />

  <!-- "J" path -->
  <path
    d="M80.8652 0.5V313.974C79.885 336.281 76.2359 346.621 62.1838 361.277C41.5444 377.516 28.8551 374.692 0.5 365.513V446C92.7132 465.459 163.089 405.861 169.69 313.974V0.5H80.8652Z"
    fill={fillColor}
  />
</svg>

<style lang="postcss">
  svg {
    @apply inline-block;
    @apply transition-all duration-200;
  }

  svg:hover {
    @apply opacity-90;
  }
</style>
